import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { RootLayout } from '@/layouts/RootLayout';
import { AppRoutes } from '@/routes';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <RootLayout>
          <AppRoutes />
        </RootLayout>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
